import { render, staticRenderFns } from "./UseRecord.vue?vue&type=template&id=07586cd4&"
import script from "./UseRecord.vue?vue&type=script&lang=js&"
export * from "./UseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports